module.exports = __webpack_public_path__ + "img/azul.png";